import { HomeSectionBannerResponseDto } from '@/apis/rest/generated/types'
import { ImageBannerSlider } from '@/components/domains/home/new/image-banner-slider'
import { FitpetMallEventEnum } from '@/utils/event-tracker/events'

interface HomeBottomBannerProps {
  homeSectionItem: HomeSectionBannerResponseDto
}

export const HomeBannerBottom = ({ homeSectionItem }: HomeBottomBannerProps) => {
  const eventTrackerName = {
    view: FitpetMallEventEnum.ViewHomeBanner,
    click: FitpetMallEventEnum.ClickHomeBanner,
  }

  return (
    <ImageBannerSlider
      banners={homeSectionItem.imageTypeBanners}
      eventTrackerName={eventTrackerName}
      bannerStyles={{
        height: 112,
        logoWidth: 68,
      }}
    />
  )
}
